module.exports = __webpack_public_path__ + "static/img/2.439ea5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/2.jpg
// module id = v2G5
// module chunks = 2